<template>
  <div class="variable-picker text-left">
    <!-- button -->
    <b-btn size="sm" v-b-modal="refId">{{ buttonLabel }}...</b-btn>

    <b-modal :id="refId" :ref="refId" size="md" lazy hide-footer>
      <!-- header / toggle showAll -->

      <template slot="modal-header">
        <h5 class="my-0">{{ headerLabel }}</h5>
        <b-button class="float-right" size="sm" @click="close">Done</b-button>
      </template>
      <ChartsCheckboxes
        :initial-sections="sections"
        :initial-derived-variables="derivedVariables"
        ref="favoritesPicker"
      >
      </ChartsCheckboxes>
    </b-modal>
  </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue';
import Questionnaire from '@/providers/Questionnaire.js';
import ChartsCheckboxes from '@/components/survey/results/ChartsCheckboxes';

export default Vue.extend({
  name: 'FavoriteQuestionsSelector',
  components: {
    ChartsCheckboxes,
  },
  props: {
    buttonLabel: String,
    headerLabel: String,
    refId: String,
    questionnaire: Object,
    ids: Object, // format: { derivedVarNames: [], questionIds: [], variableIds: [] }
  },
  computed: {
    derivedVariables: function () {
      const selectedNames = (this.ids || {}).derivedVarNames || [];
      return Questionnaire.getDerivedVariables(selectedNames);
    },
    sections: function () {
      const selectedQsIds = (this.ids || {}).questionIds || [];
      const selectedVIds = (this.ids || {}).variableIds || [];
      return Questionnaire.getQuestionnaireSections(
        this.questionnaire.sections,
        selectedQsIds,
        selectedVIds
      );
    },
  },
  methods: {
    close() {
      this.$emit('selected', this.$refs.favoritesPicker.getSelected());
      this.$refs[this.refId].hide();
    },
  },
});
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
.variable-picker {
  display: inline-block;
}
</style>
